export const HEADERS = [
  { label: "หมายเลขการจอง", key: "reserveId",},
  { label: "รหัส SO", key: "saleOrder" },
  { label: "รหัส Invoice", key: "invoiceId" },
  { label: "รหัสเซลล์", key: "saleCode" },
  { label: "รหัสลูกค้า", key: "customerCode" },
  { label: "เงื่อนไข", key: "reserveType" },
  { label: "เงื่อนไขการแลก", key: "exchangeCondition" },
  { label: "จำนวน", key: "quantity" },
  { label: "วันที่จอง", key: "createDate" },
  { label: "รายการออเดอร์", key: "detail" },
  { label: "หมายเหตุ", key: "remark" },
  { label: "สถานที่จัดส่ง", key: "addressName" },
  { label: "สถานะ", key: "reserveStatusId" }
];
